import moment from 'moment';

const getWorkDateOptionsResponse = (response) => {
  return response?.workDates?.map((date, index) => ({
    label: moment(date).format('DD MMMM YYYY'),
    value: moment(date).format('YYYY-MM-DD'),
    ...(index === 1 && { labelDescription: 'Jika live di esok hari' }),
  }));
};

export default getWorkDateOptionsResponse;
